// Shared sample-data + shared bits for the YT AI Replies UI shells. Consumed
// by YTRepliesConsoleCard.jsx (Workbench Channel 1 + Refinery Channel 2) and
// YTRepliesChatPane.jsx (bottom of Silo Assistant / Chat tab). All static —
// real drafts land once the backend worker + OAuth wiring ships. (Randy, Jul 2026)

export const SLOT_META = {
  channel1: { name: "Channel 1", where: "Workbench" },
  channel2: { name: "Channel 2", where: "Refinery" },
};

export const SAMPLE_DRAFTS = {
  channel1: [
    {
      id: "d1",
      videoTitle: "Best budget laptops for college in 2026 — my full guide",
      videoTimeAgo: "2h ago",
      author: "@jasonmiller",
      authorInitials: "JM",
      commentText: "Which laptop would you recommend for a college freshman under $800?",
      draftReply: "Great question — I covered this exactly in my Aug review. Under $800, the Acer Swift 3 is the sweet spot for battery life and build quality. Full breakdown here: youtu.be/xyz",
      llmCost: 0.018,
      confidence: 0.94,
    },
    {
      id: "d2",
      videoTitle: "5 keyboard mistakes new home-studio builders make",
      videoTimeAgo: "6h ago",
      author: "@sarahwatchesalot",
      authorInitials: "SW",
      commentText: "Would this same setup work if I'm mainly recording acoustic guitar?",
      draftReply: "Yes — the mic pattern is what matters most for acoustic. Swap the SM57 for the LDC I mention around 4:12, keep everything else the same. Full acoustic-focused build here: yt.me/randyacoustic",
      llmCost: 0.021,
      confidence: 0.89,
    },
    {
      id: "d3",
      videoTitle: "Why my old truck won't start (fixed it live)",
      videoTimeAgo: "1d ago",
      author: "@dieselmike92",
      authorInitials: "DM",
      commentText: "Same thing happened to my 89 Ford, ended up being the crank sensor. Worth a check!",
      draftReply: null, // skipped — statement, not a question
      skippedReason: "Not a question — auto-skipped",
    },
  ],
  channel2: [
    {
      id: "d4",
      videoTitle: "Podcast episode 47 — Building a family of readers",
      videoTimeAgo: "45m ago",
      author: "@homeschoolmomtn",
      authorInitials: "HM",
      commentText: "What age did you start Charlotte Mason with your kids, and did you use the free curriculum or paid?",
      draftReply: "We started around age 5 — the free Ambleside curriculum was plenty for the first two years. I broke down exactly what we added later in ep 32: yt.me/randyep32",
      llmCost: 0.019,
      confidence: 0.91,
    },
    {
      id: "d5",
      videoTitle: "How I plan my week in 15 minutes on Sunday",
      videoTimeAgo: "3h ago",
      author: "@planningnerd",
      authorInitials: "PN",
      commentText: "Do you use a digital planner or paper? I keep switching and getting nowhere.",
      draftReply: "Paper for weekly review, digital for the calendar — the specific split matters more than the tool. Full workflow at mysilo.app/randy/planning",
      llmCost: 0.017,
      confidence: 0.87,
    },
  ],
};

export const SAMPLE_STATS = {
  channel1: { pending: 2, postedToday: 7, clicksThisWeek: 43, approvalsInARow: 0 },
  channel2: { pending: 2, postedToday: 3, clicksThisWeek: 18, approvalsInARow: 0 },
};
